module.exports = __webpack_public_path__ + "static/media/section.884f6111.svg";